import { Tooltip } from 'antd'
import dayjs from 'dayjs'
import CustomTag from 'general/components/CustomTag'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import { REGISTRATION_STATUS } from 'general/constants/AppConstants'
import AppData from 'general/constants/AppData'
import RegistrationHelper from 'general/helpers/RegistrationHelper'

const Item = ({ data }) => {
  return (
    <Tooltip title={data}>
      <div
        style={{
          width: '100%',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {data}
      </div>
    </Tooltip>
  )
}

export const getColumns = ({
  isDeleteRegistration,
  isEditRegistration,
  initialChangeDeclarationId,
  navigate,
  syncRegistration,
  viewPdfRegistration,
  setActiveRegistration,
  toggleModal,
}) => {
  const isAllowPullRegistration = (row) =>
    ![
      REGISTRATION_STATUS.DRAFT,
      REGISTRATION_STATUS.TAX_ACCEPT,
      REGISTRATION_STATUS.TAX_NOT_ACCEPT,
      REGISTRATION_STATUS.CONVERTED,
      REGISTRATION_STATUS.INACTIVE,
    ].includes(row.status)

  const isAllowSeeHistory = (row) =>
    ![
      REGISTRATION_STATUS.DRAFT,
      REGISTRATION_STATUS.CONVERTED,
      REGISTRATION_STATUS.INACTIVE,
    ].includes(row.status)

  const isAllowDeleteRegistration = (row) =>
    [REGISTRATION_STATUS.DRAFT, REGISTRATION_STATUS.CONVERTED].includes(
      row.status,
    )

  const isAllowEdit = (row) =>
    [REGISTRATION_STATUS.DRAFT, REGISTRATION_STATUS.CONVERTED].includes(
      row.status,
    )

  const isAllowUpdateSTT = (row) => row?.isInitialChangeDeclaration

  return [
    {
      name: 'Ngày lập',
      // sortable: true,
      // sortFunction: (a, b) => {
      //   const dateA = dayjs(a.date)
      //   const dateB = dayjs(b.date)
      //   if (dateA.isBefore(dateB)) {
      //     return -1
      //   } else if (dateA.isAfter(dateB)) {
      //     return 1
      //   }
      //   return 0
      // },
      center: true,
      style: {
        justifyContent: 'flex-start',
      },
      grow: 0,
      minWidth: '120px',

      format: (row) => (
        <b className="m-0 font-weight-bold">{dayjs(row?.date).format('L')}</b>
      ),
      selector: (row) => row?.date,
    },
    {
      name: 'Số',
      center: true,
      // sortable: true,
      // sortFunction: (a, b) => {
      //   if (!a.no || !b.no) return 0
      //   return a.no.localeCompare(b.no)
      // },
      style: {
        justifyContent: 'flex-start',
      },
      grow: 0,
      minWidth: '140px',
      format: (row) => <Tooltip title={row?.no}>{row?.no}</Tooltip>,
      selector: (row) => row?.no,
    },

    {
      name: 'Hình thức tờ khai',
      center: true,

      // sortable: true,
      // sortFunction: (a, b) => {
      //   if (a.type - b.type > 0) {
      //     return 1
      //   } else if (a.type - b.type < 0) {
      //     return -1
      //   }
      //   return 0
      // },
      grow: 0,
      minWidth: '170px',
      selector: (row) => row?.type,
      cell: (row) => {
        const data = RegistrationHelper.renderRegistrationType(row?.type)
        return <Item data={data} />
      },
    },
    {
      name: 'Hình thức hóa đơn',
      center: true,
      // sortable: true,
      // sortFunction: (a, b) => {
      //   if (!a || !b) return 0
      //   return RegistrationHelper.renderInvoiceFormsOfRegistration(
      //     a,
      //   ).localeCompare(
      //     RegistrationHelper.renderInvoiceFormsOfRegistration(b),
      //   )
      // },
      minWidth: '380px',
      cell: (row) => {
        const data = RegistrationHelper.renderInvoiceFormsOfRegistration(row)
        return <Item data={data} />
      },
    },
    {
      name: 'Thông báo tiếp nhận',
      minWidth: '250px',
      center: true,

      // sortable: true,
      // sortFunction: (a, b) => {
      //   let aT = a?.tax_authority_messages?.find(
      //     ({ typeCode }) => typeCode == 102,
      //   )?.messageId
      //   let bT = b?.tax_authority_messages?.find(
      //     ({ typeCode }) => typeCode == 102,
      //   )?.messageId
      //   if (!aT || !bT) return 0
      //   return aT.localeCompare(bT)
      // },
      cell: (row) => {
        const data = row?.tax_authority_messages?.find(
          ({ typeCode }) => typeCode == 102,
        )?.messageId
        return <Item data={data} />
      },
    },
    {
      name: 'Thông báo chấp nhận',
      sortable: true,
      grow: 0,
      center: true,
      minWidth: '250px',
      cell: (row) => {
        const data = row?.tax_authority_messages?.find(
          ({ typeCode }) => typeCode == 103,
        )?.messageId
        return <Item data={data} />
      },
    },
    {
      name: 'Trạng thái',
      center: true,
      style: {
        justifyContent: 'flex-start',
      },

      // sortable: true,
      // sortFunction: (a, b) => {
      //   let aT = RegistrationHelper.renderRegistrationStatus(a?.status)
      //   let bT = RegistrationHelper.renderRegistrationStatus(b?.status)
      //   if (!aT || !bT) return 0
      //   return aT.localeCompare(bT)
      // },

      cell: (row) => {
        let color
        switch (row?.status) {
          case REGISTRATION_STATUS.DRAFT:
            color = 'secondary'
            break
          case REGISTRATION_STATUS.TAX_VALID:
          case REGISTRATION_STATUS.SENT_TAX:
            color = 'success'
            break
          case REGISTRATION_STATUS.TAX_NOT_VALID:
          case REGISTRATION_STATUS.TAX_NOT_RECEIVE:
          case REGISTRATION_STATUS.TAX_NOT_ACCEPT:
          case REGISTRATION_STATUS.INACTIVE:
            color = 'danger'
            break
          default:
            color = 'primary'
            break
        }

        return (
          <CustomTag
            tagProps={{
              className: `badge badge-light-${color}`,
              // 'data-tag': 'allowRowEvents',
            }}
            style={{ margin: 0 }}
            text={RegistrationHelper.renderRegistrationStatus(row?.status)}
          />
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      disabled: true,
      grow: 0,
      minWidth: '140px',

      cell: (row) => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'start',
              width: '100%',
              gap: '8px',
            }}
          >
            <TableAction
              titleActionText="Xem chi tiết"
              icon={<EyeIcon size={19} />}
              onClick={() => viewPdfRegistration(row.registrationId)}
            />
            {isAllowEdit(row) && (
              <TableAction
                titleActionText="Sửa"
                icon={<EditIcon size={19} />}
                onClick={() => {
                  if (isEditRegistration) navigate(`sua/${row.registrationId}`)
                  if (!isEditRegistration) toggleModal('noRight', true)
                }}
              />
            )}
            {isAllowSeeHistory(row) && (
              <TableAction
                titleActionText="Xem lịch sử truyền nhận"
                icon={<HistoryIcon size={19} />}
                onClick={() => {
                  setActiveRegistration(row)
                  toggleModal('dataTransmissionLog', true)
                }}
              />
            )}
            {isAllowPullRegistration(row) && (
              <TableAction
                titleActionText="Cập nhật trạng thái tờ khai"
                icon={<ReloadIcon size={19} />}
                onClick={() => {
                  syncRegistration(row.messageId)
                }}
              />
            )}

            {isAllowUpdateSTT(row) && (
              <TableAction
                titleActionText="Cập nhật STT bắt đầu mã CQT"
                icon={<PlusIcon size={19} />}
                onClick={() => {
                  toggleModal('updateSTT', { state: true, data: row })
                }}
              />
            )}

            {isAllowDeleteRegistration(row) && (
              <TableAction
                titleActionText="Xóa"
                icon={<DeleteIcon size={19} />}
                onClick={() => {
                  if (isDeleteRegistration) {
                    setActiveRegistration(row)
                    toggleModal('delete', true)
                  }
                  if (!isDeleteRegistration) toggleModal('noRight', true)
                }}
              />
            )}
          </div>
        )
      },
    },
  ]
}
const EyeIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.75 9C0.75 9 3.75 3 9 3C14.25 3 17.25 9 17.25 9C17.25 9 14.25 15 9 15C3.75 15 0.75 9 0.75 9Z"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
const EditIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_609_2473)">
      <path
        d="M8.25 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9.75"
        stroke="#3C4376"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.875 1.875C14.1734 1.57663 14.578 1.40901 15 1.40901C15.422 1.40901 15.8266 1.57663 16.125 1.875C16.4234 2.17337 16.591 2.57805 16.591 3C16.591 3.42196 16.4234 3.82663 16.125 4.125L9 11.25L6 12L6.75 9L13.875 1.875Z"
        stroke="#3C4376"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_609_2473">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
const HistoryIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.47852 8.00003C1.47852 9.28991 1.86101 10.5508 2.57763 11.6233C3.29424 12.6958 4.3128 13.5317 5.50449 14.0253C6.69618 14.5189 8.00749 14.6481 9.27258 14.3965C10.5377 14.1448 11.6997 13.5237 12.6118 12.6116C13.5239 11.6995 14.145 10.5375 14.3967 9.27236C14.6483 8.00727 14.5192 6.69596 14.0256 5.50427C13.5319 4.31258 12.696 3.29402 11.6235 2.57741C10.551 1.86079 9.29013 1.47829 8.00025 1.47829C6.17703 1.48515 4.42704 2.19657 3.1162 3.4638L1.47852 5.10148"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.47852 1.47829V5.10148H5.1017M8.00025 4.37684V8.00003L10.8988 9.44931"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

const PlusIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size - 3}
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.125 7H10.875M8.5 4.62499V9.375M3.75 12.5417C3.33007 12.5417 2.92735 12.3748 2.63041 12.0779C2.33348 11.781 2.16667 11.3783 2.16667 10.9583V7.79166L1.375 7L2.16667 6.20833V3.04166C2.16667 2.62174 2.33348 2.21901 2.63041 1.92208C2.92735 1.62514 3.33007 1.45833 3.75 1.45833M13.25 12.5417C13.6699 12.5417 14.0727 12.3748 14.3696 12.0779C14.6665 11.781 14.8333 11.3783 14.8333 10.9583V7.79166L15.625 7L14.8333 6.20833V3.04166C14.8333 2.62174 14.6665 2.21901 14.3696 1.92208C14.0727 1.62514 13.6699 1.45833 13.25 1.45833"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

const ReloadIcon = ({ size = 18 }) => (
  <svg
    width={size - 2}
    height={size}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.41736 11.1667H1.45903V15.125M8.58403 4.83333H12.5424V0.875M1.12891 5.62738C1.57287 4.52889 2.31606 3.57697 3.27403 2.87979C4.23199 2.18261 5.36632 1.76812 6.54809 1.68343C7.72987 1.59874 8.9117 1.84725 9.95929 2.40071C11.0069 2.95417 11.8782 3.79038 12.4743 4.81433M12.8733 10.3726C12.4294 11.4713 11.6862 12.4234 10.7282 13.1208C9.77013 13.8181 8.63567 14.2327 7.45374 14.3174C6.27181 14.4021 5.08983 14.1535 4.04215 13.5999C2.99446 13.0463 2.1231 12.2098 1.52711 11.1857"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
const DeleteIcon = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 4.5H3.75H15.75"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.25 4.5V15C14.25 15.3978 14.092 15.7794 13.8107 16.0607C13.5294 16.342 13.1478 16.5 12.75 16.5H5.25C4.85218 16.5 4.47064 16.342 4.18934 16.0607C3.90804 15.7794 3.75 15.3978 3.75 15V4.5M6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72064 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5"
      stroke="#3C4376"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export const getColumnsAccountingDocuments = ({
  isDeleteRegistration,
  isEditRegistration,
  initialChangeDeclarationId,
  navigate,
  syncRegistration,
  viewPdfRegistration,
  setActiveRegistration,
  toggleModal,
}) => {
  const isAllowPullRegistration = (row) =>
    ![
      REGISTRATION_STATUS.DRAFT,
      REGISTRATION_STATUS.TAX_ACCEPT,
      REGISTRATION_STATUS.TAX_NOT_ACCEPT,
      REGISTRATION_STATUS.CONVERTED,
      REGISTRATION_STATUS.INACTIVE,
    ].includes(row.status)

  const isAllowSeeHistory = (row) =>
    ![
      REGISTRATION_STATUS.DRAFT,
      REGISTRATION_STATUS.CONVERTED,
      REGISTRATION_STATUS.INACTIVE,
    ].includes(row.status)

  const isAllowDeleteRegistration = (row) =>
    [REGISTRATION_STATUS.DRAFT, REGISTRATION_STATUS.CONVERTED].includes(
      row.status,
    )

  const isAllowEdit = (row) =>
    [REGISTRATION_STATUS.DRAFT, REGISTRATION_STATUS.CONVERTED].includes(
      row.status,
    )

  const isAllowUpdateSTT = (row) => row?.isInitialChangeDeclaration

  return [
    {
      name: 'Ngày lập',
      // sortable: true,
      // sortFunction: (a, b) => {
      //   const dateA = dayjs(a.date)
      //   const dateB = dayjs(b.date)
      //   if (dateA.isBefore(dateB)) {
      //     return -1
      //   } else if (dateA.isAfter(dateB)) {
      //     return 1
      //   }
      //   return 0
      // },
      center: true,
      style: {
        justifyContent: 'flex-start',
      },
      grow: 0,
      minWidth: '120px',

      format: (row) => (
        <b className="m-0 font-weight-bold">{dayjs(row?.date).format('L')}</b>
      ),
      selector: (row) => row?.date,
    },
    {
      name: 'Số',
      center: true,
      // sortable: true,
      // sortFunction: (a, b) => {
      //   if (!a.no || !b.no) return 0
      //   return a.no.localeCompare(b.no)
      // },
      style: {
        justifyContent: 'flex-start',
      },
      grow: 0,
      minWidth: '140px',
      format: (row) => <Tooltip title={row?.no}>{row?.no}</Tooltip>,
      selector: (row) => row?.no,
    },

    {
      name: 'Hình thức tờ khai',
      center: true,

      // sortable: true,
      // sortFunction: (a, b) => {
      //   if (a.type - b.type > 0) {
      //     return 1
      //   } else if (a.type - b.type < 0) {
      //     return -1
      //   }
      //   return 0
      // },
      grow: 0,
      minWidth: '170px',
      selector: (row) => row?.type,
      cell: (row) => {
        const data = RegistrationHelper.renderRegistrationType(row?.type)
        return <Item data={data} />
      },
    },
    {
      name: 'Hình thức gửi dữ liệu',
      center: true,
      // sortable: true,
      // sortFunction: (a, b) => {
      //   if (!a || !b) return 0
      //   return RegistrationHelper.renderInvoiceFormsOfRegistration(
      //     a,
      //   ).localeCompare(
      //     RegistrationHelper.renderInvoiceFormsOfRegistration(b),
      //   )
      // },
      minWidth: '300px',
      cell: (row) => {
        return (
          <div className="row">
            <div className="col-12" style={{ lineHeight: 2 }}>
              {row?.[
                AppData.userType_registrationAccountingDocument
                  ?.dataSubmissionMethodPortal.name
              ] ? (
                AppData.userType_registrationAccountingDocument
                  ?.dataSubmissionMethodPortal.label
              ) : (
                <></>
              )}
            </div>
            <div className="col-12" style={{ lineHeight: 2 }}>
              {row?.[
                AppData.userType_registrationAccountingDocument
                  ?.dataSubmissionMethodTvan.name
              ] ? (
                AppData.userType_registrationAccountingDocument
                  ?.dataSubmissionMethodTvan.label
              ) : (
                <></>
              )}
            </div>
            <div className="col-12" style={{ lineHeight: 2 }}>
              {row?.[
                AppData.userType_registrationAccountingDocument
                  ?.dataSubmissionMethodTvanAuthorized.name
              ] ? (
                AppData.userType_registrationAccountingDocument
                  ?.dataSubmissionMethodTvanAuthorized.label
              ) : (
                <></>
              )}
            </div>
          </div>
        )
      },
    },
    {
      name: 'Thông báo tiếp nhận',
      width: '250px',
      center: true,

      // sortable: true,
      // sortFunction: (a, b) => {
      //   let aT = a?.tax_authority_messages?.find(
      //     ({ typeCode }) => typeCode == 102,
      //   )?.messageId
      //   let bT = b?.tax_authority_messages?.find(
      //     ({ typeCode }) => typeCode == 102,
      //   )?.messageId
      //   if (!aT || !bT) return 0
      //   return aT.localeCompare(bT)
      // },
      cell: (row) => {
        const data = row?.tax_authority_messages?.find(
          ({ typeCode }) => typeCode == 110,
        )?.messageId
        return <Item data={data} />
      },
    },
    {
      name: 'Thông báo chấp nhận',
      sortable: true,
      grow: 0,
      center: true,
      width: '250px',
      cell: (row) => {
        const data = row?.tax_authority_messages?.find(
          ({ typeCode }) => typeCode == 111,
        )?.messageId
        return <Item data={data} />
      },
    },
    {
      name: 'Trạng thái',
      center: true,
      width: '150px',
      style: {
        justifyContent: 'flex-start',
      },

      // sortable: true,
      // sortFunction: (a, b) => {
      //   let aT = RegistrationHelper.renderRegistrationStatus(a?.status)
      //   let bT = RegistrationHelper.renderRegistrationStatus(b?.status)
      //   if (!aT || !bT) return 0
      //   return aT.localeCompare(bT)
      // },

      cell: (row) => {
        let color
        switch (row?.status) {
          case REGISTRATION_STATUS.DRAFT:
            color = 'secondary'
            break
          case REGISTRATION_STATUS.TAX_VALID:
          case REGISTRATION_STATUS.SENT_TAX:
            color = 'success'
            break
          case REGISTRATION_STATUS.TAX_NOT_VALID:
          case REGISTRATION_STATUS.TAX_NOT_RECEIVE:
          case REGISTRATION_STATUS.TAX_NOT_ACCEPT:
          case REGISTRATION_STATUS.INACTIVE:
            color = 'danger'
            break
          default:
            color = 'primary'
            break
        }

        return (
          <CustomTag
            tagProps={{
              className: `badge badge-light-${color}`,
              // 'data-tag': 'allowRowEvents',
            }}
            style={{ margin: 0 }}
            text={RegistrationHelper.renderRegistrationStatus(row?.status)}
          />
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      disabled: true,
      grow: 0,
      minWidth: '140px',

      cell: (row) => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'start',
              width: '100%',
              gap: '8px',
            }}
          >
            <TableAction
              titleActionText="Xem chi tiết"
              icon={<EyeIcon size={19} />}
              onClick={() => viewPdfRegistration(row.registrationId)}
            />
            {isAllowEdit(row) && (
              <TableAction
                titleActionText="Sửa"
                icon={<EditIcon size={19} />}
                onClick={() => {
                  if (isEditRegistration) navigate(`sua/${row.registrationId}`)
                  if (!isEditRegistration) toggleModal('noRight', true)
                }}
              />
            )}
            {isAllowSeeHistory(row) && (
              <TableAction
                titleActionText="Xem lịch sử truyền nhận"
                icon={<HistoryIcon size={19} />}
                onClick={() => {
                  setActiveRegistration(row)
                  toggleModal('dataTransmissionLog', true)
                }}
              />
            )}
            {isAllowPullRegistration(row) && (
              <TableAction
                titleActionText="Cập nhật trạng thái tờ khai"
                icon={<ReloadIcon size={19} />}
                onClick={() => {
                  syncRegistration(row.messageId)
                }}
              />
            )}

            {isAllowUpdateSTT(row) && (
              <TableAction
                titleActionText="Cập nhật STT bắt đầu mã CQT"
                icon={<PlusIcon size={19} />}
                onClick={() => {
                  toggleModal('updateSTT', { state: true, data: row })
                }}
              />
            )}

            {isAllowDeleteRegistration(row) && (
              <TableAction
                titleActionText="Xóa"
                icon={<DeleteIcon size={19} />}
                onClick={() => {
                  if (isDeleteRegistration) {
                    setActiveRegistration(row)
                    toggleModal('delete', true)
                  }
                  if (!isDeleteRegistration) toggleModal('noRight', true)
                }}
              />
            )}
          </div>
        )
      },
    },
  ]
}
